import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import EyesImage from '../assets/images/eyes.png';
import Navigation from './Navigation';

const Hero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  
  return (
    <Box
      sx={{
        width: '100%',
        height: { xs: 'calc(100vh - 20px)', sm: 'calc(100vh - 10px)', md: '100vh' },
        position: 'relative',
        zIndex: 1,
        background: '#050505',
        overflow: 'hidden',
      }}
    >
      <Navigation />
      
      {/* Eye Image Background - Ensure it's behind all content with lower z-index */}
      <Box
        component="img"
        src={EyesImage}
        alt="Background Eyes"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: { 
            xs: 'cover', 
            sm: 'cover', 
            md: 'cover' 
          },
          objectPosition: { 
            xs: 'center center', 
            sm: 'center center',
            md: 'center center' 
          },
          opacity: { 
            xs: 0.5, 
            sm: 0.55, 
            md: 0.6 
          },
          zIndex: 0,
          transform: { 
            xs: 'scale(1.1)', 
            sm: 'scale(1.1)',
            md: isLargeScreen ? 'scale(1)' : 'scale(1.05)' 
          },
          maxWidth: '100%',
          pointerEvents: 'none', // Ensure image doesn't interfere with clicks
        }}
      />
      
      {/* This placeholder ensures the hero section has proper spacing */}
      <Box 
        sx={{
          position: 'relative',
          zIndex: 1, // Above the sun, below nav
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: { 
            xs: '1rem', 
            sm: '2rem', 
            md: '3rem' 
          }
        }}
      />
    </Box>
  );
};

export default Hero; 